import { useEffect, useState } from 'react'
import { getFilterSearchParameters } from '../helpers'

export const useFilters = (fetchData: () => void) => {
  const [filterParams, setFilterParams] = useState<Record<string, string>>({})
  const changeSearchParams = (name: string, value: string) => {
    const url = new URL(location.href)
    url.searchParams.delete(name)
    url.searchParams.append(name, value)
    if (name === 'category') {
      url.searchParams.delete('theme')
    }

    history.replaceState(null, '', url.toString())

    setFilterParams(getFilterSearchParameters())
  }

  const changeSearchQuery = (...args: { name: string; value: string }[]) => {
    for (let i = 0; i < args.length; i++) {
      changeSearchParams(args[i].name, args[i].value)
    }

    fetchData()
  }

  useEffect(() => {
    setFilterParams(getFilterSearchParameters())
  }, [])

  return {
    formValues: filterParams,
    onChangeQuery: changeSearchQuery
  }
}
